module.exports = new __parcel__URL__("error-loading-file.02dc84f6.svg").toString();